import { FiHelpCircle } from "react-icons/fi";
import Logo from "../../../assets/home/logo.svg";

const TestHeader = ({
  secondsLeft,
  onPause,
  isRunning,
  testName,
  testMeta,
  onInstructions,
}) => {
  const formatTime = (sec = 0) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  console.log('secondsLeft', secondsLeft);

  return (
    <header className="w-full bg-[#F5F7FA] border-b flex items-center px-4 md:px-6 py-3 sticky top-0 z-50">
      <div className="w-full max-w-[1400px] mx-auto flex justify-between items-center">
        <img src={Logo} className="w-[150px]" />

        <div className="hidden md:flex flex-col items-center">
          <h1 className="text-[26px] font-[500]">{testName}</h1>
          <p className="text-[16px] font-[600]">{testMeta}</p>
        </div>

        <div className="flex gap-2 md:gap-3  items-center">
          <div className="bg-[#4096F6] text-white px-4 py-2 rounded">
            {formatTime(secondsLeft)}
          </div>

          <button
            onClick={onPause}
            className="bg-[#4096F6] text-white px-4 py-2 rounded"
          >
            {isRunning ? "Pause Test" : "Resume Test"}
          </button>

          <button
            onClick={onInstructions}
            className="border border-red-500 text-red-500 px-4 py-2 rounded hidden lg:flex"
          >
            <FiHelpCircle /> Instructions
          </button>
        </div>
      </div>
    </header>
  );
};

export default TestHeader;
